import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.background.secondary};
  border-radius: ${props => props.theme.primitives.radius.radius1};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  svg {
    flex-shrink: 0;
  }
`

export const ChipContainer = styled.div`
  display: flex;
`
